import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import utils from '../../utils/utilities.js';
import FormGroup from './FormGroup.jsx';

// Move to FormTypes
export const CheckOptionType = PropTypes.shape({
    label: PropTypes.any,
    value: PropTypes.any,
    extra: PropTypes.object
});

class ChecksGroup extends Component {

    static propTypes = {
        onChange: PropTypes.func,
        options: PropTypes.arrayOf(CheckOptionType),
        selectAll: PropTypes.any,
        classNames: PropTypes.string,
        label: PropTypes.any,
        hasError: PropTypes.any,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        fieldId: PropTypes.string
    }

    static defaultProps = {
        selectAll: null,
        label: null,
        hasError: false,
        disabled: false,
        required: false,
        classNames: "",
        fieldId: "checksGroup_" + utils.generateRandomHash()
    }

    constructor(props) {
        super(props);

        this.state = {
            selectedAll: !!props.selectAll
        }
    }

    onChange(option, e) {
        const index = this.props.options.indexOf(option);
        let newOptions = this.props.options;
        newOptions[index].value = !option.value;
        this.props.onChange(newOptions, option, e);
    }


    render() {
        const checkboxes = this.props.options.map((option, index) =>
            (<div key={this.props.fieldId + index}>
                <input
                    type="checkbox"
                    name={this.props.fieldId}
                    value={option.value}
                    id={this.props.fieldId + index}
                    checked={option.value}
                    disabled={!!option.disabled || this.props.disabled}
                    onChange={(e) => this.onChange(option, e)}
                    { ...option.extra }
                />
                <label title={typeof(option.label) !== 'object' ? option.label : this.props.intl.formatMessage({id: option.label.props.id}) } htmlFor={this.props.fieldId + index}>{option.label}</label>
            </div>))

        return (
            <FormGroup {...this.props} fieldId={this.props.fieldId} classNames={this.props.classNames + " checks-group"}>
                {checkboxes}
            </FormGroup>
        )
    }
}
export default injectIntl(ChecksGroup, { withRef: true });



// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/ChecksGroup.jsx